<style>
  .login-dialog {
    width: 350px;
    height: 330px;
    padding: 30px 30px 10px 30px;
  }

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }
</style>
<template>
  <div>
    <el-dialog style="padding: 10px"
               top="20%"
               title="企业湾账号登录"
               v-model="isVisible"
               custom-class="login-dialog"
               ref="dialog">
      <el-form autocomplete="off"
               label-position="top"
               ref="loginForm"
               :rules="rules"
               :model="formStacked">
        <el-form-item prop="phone">
          <el-input v-model="formStacked.phone" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item prop="captcha">
          <el-input v-model="formStacked.captcha"
                    placeholder="验证码"
                    style="width: 50%; float:left; margin-right: 10px;"></el-input>
          <el-button type="primary"
                     :disabled="isWaiting"
                     @click.native.prevent="requestCaptcha"
                     style="background: #007fff;width: 46%;border-radius: 1px;border: none;">
            {{ isWaiting ? timerShow : "点击获取" }}
          </el-button>
        </el-form-item>
      </el-form>
      <div class="clearfix"></div>
      <el-button type="primary"
                 @click.native="submit"
                 :loading="isLogging"
                 style="width: 100%;background: #007fff;border-radius: 2px;border: none;padding: 0.7em;font-size: 18px;">
        {{ isLogging ? "登录中" : "登 录" }}
      </el-button>
      <div class="clearfix"></div>
      <div style="width: 100%;">
        <el-button type="text"
                   @click.native="jumpToRegister"
                   style="color: #00A7FF;float: left;">
          快速注册
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        isVisible: false,
        checked: false,
        formStacked: {
          phone: '',
          captcha: ''
        },
        isLogging: false,
        isWaiting: false,
        timer: 60,
        error: null,
        rules: {
          phone: [
            {
              required: true,
              message: '请输入手机号',
              trigger: 'blur'
            }
          ],
          captcha: [
            {
              required: true,
              message: '请输入验证码',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    computed: {
      timerShow () {
        return this.timer + '秒'
      }
    },
    methods: {
      counterDown () {
        setTimeout(() => {
          if (this.timer === 0) {
            this.isWaiting = false
            return true
          }
          this.timer -= 1
          this.counterDown()
        }, 1000)
      },
      jumpToRegister () {
        this.$emit('register')
        this.isVisible = false
      },
      jumpToResetPassword () {
        this.$emit('reset-password')
        this.isVisible = false
      },
      openDialog () {
        this.error = ''
        this.$refs.dialog.open()
      },
      submit () {
        let vm = this
        this.$refs.loginForm.validate(function (valid) {
          if (valid) {
            vm.isLogging = true
            vm.$store.dispatch('userLogin', {
              phone: vm.formStacked.phone,
              password: vm.formStacked.password
            }).then(function () {
              vm.isVisible = false
              vm.formStacked.password = ''
              vm.isLogging = false
            }, function (error) {
              vm.formStacked.password = ''
              vm.isLogging = false
              vm.$message.error(error.message)
            })
          } else {
            return false
          }
        })
        this.$refs.dialog.close()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SmsLogin.vue?3c1a0e14